module.exports = __webpack_public_path__ + "static/media/fly.dfdfd191.mp3";